import React from "react";

const Disclaimer = (props) => {
  return (
    <div className="disclaimer">
      {props.hasAsterisk && <small>*</small>}{" "}
      NO PURCHASE NECESSARY. Open to legal residents of the 50 U.S & D.C., 18
      years or older. Sweet.io account registration required. Ends 10/10/2021 or
      when all Game Pieces have been distributed (if earlier). To play and for
      Official Rules, alternate method of entry, odds and prize descriptions,
      visit <a onClick={() => props.onRulesClick()}>realmeals.sweet.io</a>. Void
      where prohibited. Sponsor: Burger King Corporation, 5707 Blue Lagoon
      Drive, Miami FL 33126.
    </div>
  );
};

export default Disclaimer;
